<template>
  <div class="app-container subject-lib-list">
    <div class="subject-lib-list-filter">
      <el-row>
        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="8">
                <el-input class="subject-lib-list-filter-value" v-model.trim="search.name" 
                  @keyup.enter.native="searchChange" placeholder="题库名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
              </el-col>
              <el-col :span="8">
                <el-input class="subject-lib-list-filter-value" v-model.trim="search.creator" 
                  @keyup.enter.native="searchChange" placeholder="创建人" clearable size="small" suffix-icon="el-icon-search"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="subject-lib-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="subject-lib-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "subject-lib-list-container">
      <avue-crud
          ref="crud"
          :option="tableOption"
          :data="tableData"
          :page="page"
          :table-loading="tableLoading"
          :before-open="handleOpenBefore"
          @refresh-change="getData"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange">

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.subject_lib_add">创建题库</el-button>
        </template>
        <template slot-scope="scope"
          slot="menu">
          <el-button type="text"
            v-if="permissions.subject_lib_edit"
            icon="el-icon-edit"
            size="mini"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.subject_lib_del"
            icon="el-icon-delete"
            size="mini"
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { getSubjectLibList, deleteSubjectLib } from '@/api/app/subject-lib'
import { subjectLibTableOption } from '@/const/crud/app/subject-lib'
import { mapGetters } from 'vuex'

export default {
  name: 'subject',
  data() {
    return {
      tableOption: subjectLibTableOption,
      search: {
        current: 1,
        size: 10,
        name: '',
        creator: '',
      },
      groupList: [],
      // 列表页面
      tableData:[],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      tableLoading: false,
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }

      if (this.search.name != "" && this.search.name.trim() != "") {
        params.name = this.search.name
      }
      if (this.search.creator != "" && this.search.creator.trim() != "") {
        params.creator = this.search.creator
      }
      this.tableLoading = true
      getSubjectLibList(params).then(response => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total
        this.tableLoading = false
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取题库列表失败',
          type: 'error'
        })
        this.tableLoading = false;
      })
    },
    caluaterSubjectCount(data) {

    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.search.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.search.size = val
      this.getList()
    },
    initPage() {
      this.page.currentPage = 1
      this.page.pageSize = this.search.size
      this.search.current = 1
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.name = '',
      this.search.creator = '',
      this.searchChange()
    },
    handleAdd: function() {
      this.$router.push({
        path: '/app/exam/subject-lib/add'
      })
    },
    handleEdit(row, index) {
      this.$router.push({
        path: `/app/exam/subject-lib/edit/${row.id}`,
      })
    },
    handleDelete(row) {
      if (row.subjectCount > 0) {
        this.$alert('禁止删除! 题库中存在题目，请清空题目后再删除题库', '警告', {
          confirmButtonText: '确定',
          type: 'error'
        })
      } else {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteSubjectLib(row.id).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            }
          }).catch(error => {
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          })
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.subject-lib-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}

.dialog-body-row {
  line-height: 36px;
}

.operation-btn {
  font-size: 12px;
  border: none;
  color: #409EFF;
  background: transparent;
  i {
    position: relative;
    top: 3px;
    display: inline-block;
    margin-top: 2px;
    width: 13px;
    height: 13px;
    margin-right: 2px;
    background-size: 12px 12px;
  }
}
</style>
